var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXNon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.045 4.173c1.214-1.242 3.205-1.264 4.447-0.049l25.057 24.507 25.057-24.507c1.242-1.214 3.232-1.192 4.447 0.049s1.192 3.232-0.049 4.447l-24.957 24.41 24.957 24.41c1.242 1.214 1.264 3.205 0.049 4.447s-3.205 1.263-4.447 0.049l-25.057-24.507-25.057 24.507c-1.242 1.214-3.232 1.192-4.447-0.049s-1.192-3.233 0.049-4.447l24.957-24.41-24.957-24.41c-1.242-1.214-1.264-3.205-0.049-4.447z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXNon);
export default __webpack_public_path__ + "static/media/x-non.571e4a2d2f418cffdfc6bc888e062098.svg";
export { ForwardRef as ReactComponent };